import { AfterViewInit, Directive, OnDestroy, inject } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { ReplaySubject, takeUntil } from 'rxjs';

/**
 * This directive is used to handle the focus of the p-multiSelect component when used in a wrapper component.
 */
@Directive({
  selector: '[appMultiSelectFocusHandler]p-multiSelect',
  standalone: true,
})
export class MultiSelectFocusHandlerDirective
  implements AfterViewInit, OnDestroy
{
  private readonly multiSelect = inject(MultiSelect);
  private readonly destroy$ = new ReplaySubject<void>(1);

  ngAfterViewInit(): void {
    this.multiSelect.onPanelHide
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.multiSelect.el.nativeElement.focus();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
